import React from 'react';
import { SvgIcon } from '@mui/material';

export default function BulitIcon(props) {
  return (
    <SvgIcon
      viewBox="0 0 9 11"
      sx={{ width: props.width || 9, height: props.height || 11 }}
      {...props}
    >
      <path d="M0 0V2L6 5.5L0 8.5V10.5L8.5 6V5L0 0Z" />
    </SvgIcon>
  );
}
